<template>
  <div class='tips__com' v-if="show">
    <van-overlay :show="show"/>
    <section class="tips__main">
      <div class="line__tip"></div>
      <div class="tips__title">
        <img src="@/assets/tips-close.png" @click="handleClose" alt="" class="tips__close">
        <div class="tips__left" @click="handleChangeChanelLeft">活动规则<span :class="{selectedLeft: selected}"></span></div>
        <div class="tips__right" @click="handleChangeChanelRight">我的奖品<span :class="{selectedRight: !selected}"></span></div>
      </div>
      <div class="tips__content" v-if="selected">
        <div class="rule" v-html="rule"></div>
      </div>
      <div class="tips__content" v-else>
        <div class="noPrize" v-if="!prizeList || prizeList.length === 0">
          未中奖
          <div class="line"></div>
        </div>
        <div class="prize" v-else v-for="(item, index) in prizeList" :key="index">
          <div class="prize__box">
            <p class="prize__name">{{item.prize_name}}</p>
            <p class="prize__time">中奖时间：{{item.created_at}}</p>
          </div>
          <p class="prize__tips">微信立减金请在1月31日前领取，有效期内，领券后7天内有效，可在微信支付时使用【工商银行借记卡】支付。支付金额需大于立减金金额</p>
          <img src="@/assets/tips-received.png" alt="" class="prize__btn" v-if="item.status === 3">
          <img src="@/assets/tips-receive.png" alt="" v-else @click="handleReveice(item.ticket)" class="prize__btn">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    }
  },
  data () {
    return {
      selected: true, // 默认是规则
      rule: '',
      prizeList: [
      ] // 奖品列表
    }
  },
  mounted () {
    this.rule = localStorage.getItem('setRule')
    const prize = localStorage.getItem('userPrize')
    this.prizeList = JSON.parse(prize)
  },
  methods: {
    handleClose () {
      this.$emit('closeTips')
    },
    handleChangeChanelLeft () {
      this.selected = true
    },
    handleChangeChanelRight () {
      this.selected = false
    },
    handleReveice (ticket) {
      this.$stat({
        event: 'receivePrize' // 上报埋点信息--开心收下
      })
      window.location.href = 'https://passport.inrice.cn/web/reduction-gold/dist/#/home?ticket=' + encodeURIComponent(ticket)
    }
  }
}
</script>

<style lang="scss" scope>
.tips__com{
  width: 100vw;
  height: 100vh;
  .tips__{
    &main{
      z-index: 2;
      position: relative;
      .selectedLeft, .selectedRight{
        position: absolute;
        top: 106px;
        width:214px;
        height:4px;
        background:rgba(242,219,203,1);
      }
      .selectedLeft{
        left: 82px;
      }
      .selectedRight{
        right: 82px;
      }
      .line__tip{
        position: absolute;
        top: 22px;
        margin: auto;
        left: 0;
        right: 0;
        z-index: 3;
        width:3px;
        height:63px;
        background: #F2DBCB;
      }
    }
    &close{
      width: 47px;
      position: absolute;
      right: 30px;
      top: 30px;
    }
    &title{
      display: flex;
      height: 106px;
      font-size:30px;
      font-family:Source Han Sans CN;
      font-weight:400;
      color:#F9DDA9;
      border-bottom: 1px solid #F2DBCB;
    }
    &left, &right{
      width: 50%;
      text-align: center;
      line-height: 106px;
    }
    &content{
      .rule{
        margin: 56px 50px;
        p{
          font-size:28px;
          font-family:Source Han Sans CN;
          font-weight:400;
          color: #F2DBCB;
        }
        height: 82vh;
        overflow: auto;
      }
      @mixin prizeBox {
        width:610px;
        margin: 39px auto;
        text-align: center;
        border:2px solid #F2DBCB;
        border-radius:7px;
        font-size:40px;
        font-family:Source Han Sans CN;
        font-weight:500;
        color: #F2DBCB;
      }
      .noPrize{
        @include prizeBox();
        height:110px;
        line-height: 110px;
      }
      .prize{
        text-align: center;
        &__box{
          @include prizeBox();
          height: 171px;
          padding-top: 36px;
        }
        &__time{
          padding-top: 10px;
          font-size:25px;
          color: #F9DDA9;
        }
        &__tips{
          text-align: left;
          margin: 0 65px;
          padding-bottom: 25px;
          font-size:25px;
          font-family:Source Han Sans CN;
          font-weight:400;
          color:#F2DBCB;
          line-height:50px;
          border-bottom: 2px solid #F9DDA9;
        }
        &__btn{
          width: 399px;
          margin-top: 50px;
        }
      }
      .line{
        width:608px;
        height:2px;
        margin: 39px auto;
        background:#F2DBCB;
        opacity:0.8;
      }
    }
  }
}
</style>
